
import Vue from "vue";

interface UnauthorizedComponentData {
	errCode: string;
	errMessage: string;
}
export default Vue.extend({
	page: {
		title: "401 - Unauthorized",
		meta: [
			{
				name: "description",
				content: "401 - Unauthorized",
			},
		],
	},
	props: {
		code: String,
		message: String,
		theme: String,
	},
	data(): UnauthorizedComponentData {
		return {
			errCode: this.code ? this.code : "auth_empty",
			errMessage: this.message ? this.message : "Auth data is missing or invalid",
		};
	},
});
